export default "__VITE_ASSET__doSpBfy1__"